import { useState } from "react";
import { usePFDataContext } from "../context/PfContext";
import RemoveFromCartIcon from "./RemoveFromCartIcon";
import CartUserInput from "./CartUserInput";


export default function cart() {
    const [isCartOpen, setIsCartOpen] = useState(false);
    const { pfData, updatePfData } = usePFDataContext();
    const toggleCart = () => setIsCartOpen(!isCartOpen);
    // Get cart items
    const cartItems = pfData.cart?.products || [];
    // get total price of products in cart
    const totalPrice = pfData.cart.products.reduce((acc, item) => acc + item.qty * item.price, 0);
    // get total quantity of products in cart
    const totalQty = pfData.cart.products.reduce((acc, item) => acc + item.qty, 0);

    return (
        <>
            {/* Cart button to toggle the flyout */}
            <button className="show__cart" onClick={toggleCart}>
                <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="24px"
                    height="24px"
                    viewBox="0 0 475.084 475.085"
                    xmlSpace="preserve"
                    aria-label="Cart Icon"
                >
                    <g>
                        <path d="M365.446,401.998c0,10.092,3.579,18.702,10.711,25.834c7.132,7.139,15.749,10.711,25.845,10.711 c10.081,0,18.698-3.572,25.83-10.711c7.139-7.132,10.711-15.742,10.711-25.834s-3.568-18.702-10.711-25.841 c-7.132-7.132-15.749-10.704-25.83-10.704c-10.096,0-18.713,3.572-25.845,10.704C369.025,383.296,365.446,391.906,365.446,401.998 z" />
                        <path d="M469.658,78.51c-3.618-3.617-7.898-5.426-12.848-5.426H113.918c-0.193-1.331-0.621-3.756-1.287-7.277 c-0.666-3.523-1.188-6.329-1.569-8.425c-0.383-2.087-1.093-4.611-2.142-7.561c-1.047-2.952-2.284-5.286-3.711-6.995 c-1.425-1.718-3.328-3.189-5.708-4.43c-2.378-1.233-5.092-1.853-8.136-1.853H18.276c-4.952,0-9.234,1.812-12.85,5.424 C1.809,45.583,0,49.868,0,54.816s1.809,9.231,5.426,12.847c3.619,3.617,7.902,5.424,12.85,5.424h58.237l50.532,234.976 c-0.378,0.76-2.329,4.373-5.852,10.848c-3.521,6.475-6.328,12.135-8.42,16.988c-2.093,4.859-3.14,8.616-3.14,11.279 c0,4.948,1.809,9.232,5.424,12.854c3.621,3.606,7.902,5.421,12.851,5.421h18.272h255.815h18.261c4.948,0,9.232-1.814,12.847-5.421 c3.62-3.621,5.427-7.905,5.427-12.854c0-4.949-1.807-9.233-5.427-12.847c-3.614-3.614-7.898-5.428-12.847-5.428h-262.66 c4.57-9.138,6.854-15.222,6.854-18.268c0-1.909-0.238-4.004-0.715-6.283s-1.047-4.805-1.713-7.569 c-0.667-2.752-1.093-4.799-1.283-6.133l298.077-34.831c4.753-0.575,8.658-2.614,11.703-6.14c3.046-3.518,4.565-7.562,4.565-12.133 V91.363C475.082,86.415,473.278,82.132,469.658,78.51z" />
                        <path d="M109.632,401.998c0,10.092,3.567,18.702,10.706,25.834c7.141,7.139,15.75,10.711,25.841,10.711 c10.085,0,18.699-3.572,25.835-10.711c7.139-7.132,10.71-15.742,10.71-25.834s-3.568-18.702-10.71-25.841 c-7.137-7.132-15.75-10.704-25.835-10.704c-10.09,0-18.704,3.572-25.841,10.704C113.203,383.296,109.632,391.906,109.632,401.998z" />
                    </g>
                </svg>
                { totalQty > 0 && (
                    <div className="cart__product-qty">
                        <span> { totalQty } </span>
                    </div>
                )}
            </button>


            {/* Flyout cart */}
            {isCartOpen && (
                <div className="flyout__cart">
                    <div className="flyout__cart--header">
                        <span className="flyout__cart--close" onClick={toggleCart}>
                            X
                        </span>
                        <h3>Cart</h3>
                    </div>

                    <div className="flyout__cart--body">
                        <div className="flyout__cart--form-wrapper">
                            <div className="flyout__cart--form">
                                {/* Item Table */}
                                <div className="flyout__cart--form-item-group">
                                    <div className="item__table">
                                        <div className="item__table-row item__table-head">
                                            <div className="item__table-cell item__table-cell--name">Item</div>
                                            <div className="item__table-cell item__table-cell--quantity">Qty</div>
                                            <div className="item__table-cell item__table-cell--price">Price</div>
                                        </div>
                                        <div className="item__table-body" id="item__table-body">
                                            {cartItems.length > 0 ? (
                                                cartItems.map((item, index) => (
                                                    <div className="item__table-row" key={item.id}>

                                                        <RemoveFromCartIcon productId={item.id} />
                                                       
                                                        <div className="item__table-cell item__table-cell--name">
                                                            <h4>{item.brand}</h4>
                                                            <p>{item.name}</p>
                                                        </div>
                                                        <div className="item__table-cell item__table-cell--quantity">
                                                            <input 
                                                                type="number" 
                                                                className="item__qunatity" 
                                                                value={item.qty} 
                                                                min="0" 
                                                                max="20" 
                                                                onChange={(e) => {
                                                                    const value = parseInt(e.target.value);
                                                                    const cart = { ...pfData.cart };
                                                                    const existingProductIndex = cart.products.findIndex((cartItem) => cartItem.id === item.id);

                                                                    if (existingProductIndex >= 0) {
                                                                        cart.products[existingProductIndex].qty = value;
                                                                        cart.products[existingProductIndex].total = value * cart.products[existingProductIndex].price;
                                                                    }

                                                                    updatePfData("cart", cart);
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="item__table-cell item__table-cell--price">${item.price}</div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="item__table-row">No items in cart.</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="total__price-wrapper">
                                        <div>Total</div>
                                        <div className="total__price">
                                            $<span className="total__price-text">{totalPrice}</span>
                                        </div>
                                    </div>
                                </div>

                                {/* User Info Form */}
                                <CartUserInput toggleCart={toggleCart} />                        
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
